import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axiosInstance from 'api/axios';
import { baseTableFilter, buildQueryString } from 'utils/general';

export const initialState = {
	loading: false,
	message: '',
	showMessage: false,
	jobFields: [],
};

export const getAllJobCategoryFields = createAsyncThunk('user/getAllJobCategoryFields', async (filter, { rejectWithValue }) => {
	try {
		const queryData = buildQueryString({
			search: filter?.search,
			startDate: filter?.startDate,
			endDate: filter?.endDate,
			isActive: filter?.isActive,
		});

		const response = await axiosInstance.get(
			`/job-field/admin?sortBy=${filter?.sortBy ?? baseTableFilter.sortBy}&page=${filter?.page ?? baseTableFilter.page ?? 1}&limit=${filter?.limit ?? baseTableFilter.limit}${queryData ? '&' + queryData : ''}`,
		);

		if (response.success) {
			return response;
		} else {
			return rejectWithValue(response.message?.replace('Firebase: ', ''));
		}
	} catch (err) {
		return rejectWithValue(err?.response || 'Error');
	}
});

export const getJobCategoryFieldsById = createAsyncThunk('user/getJobCategoryFieldsById', async (id, { rejectWithValue }) => {
	try {
		const response = await axiosInstance.get(`/job-field/${id}`);
		if (response.success) {
			return response;
		} else {
			return rejectWithValue(response.message?.replace('Firebase: ', ''));
		}
	} catch (err) {
		return rejectWithValue(err.message || 'Error');
	}
});

export const deleteJobCategoryFields = createAsyncThunk('user/deleteJobCategoryFields', async (id, { rejectWithValue }) => {
	try {
		const response = await axiosInstance.delete(`/job-field/${id}`);

		if (response.success) {
			return response;
		} else {
			return rejectWithValue(response.message?.replace('Firebase: ', ''));
		}
	} catch (err) {
		return rejectWithValue(err?.response || 'Error');
	}
});

export const editJobCategoryFields = createAsyncThunk('user/editJobCategoryFields', async ({ data, catId }, { rejectWithValue }) => {
	try {
		console.log(data, 'PAYLOAD...');

		const response = await axiosInstance.patch(`/job-field/${catId}`, data);
		console.log(response, 'response..');

		if (response.success) {
			return response;
		} else {
			return rejectWithValue(response.message?.replace('Firebase: ', ''));
		}
	} catch (err) {
		return rejectWithValue(err?.response || 'Error');
	}
});

export const addJobCategoryFields = createAsyncThunk('user/addJobCategoryFields', async (data, { rejectWithValue }) => {
	try {
		const response = await axiosInstance.post(`/job-field`, data);
		console.log(response, 'response..');

		if (response.success) {
			return response;
		} else {
			return rejectWithValue(response.message?.replace('Firebase: ', ''));
		}
	} catch (err) {
		return rejectWithValue(err || 'Error');
	}
});

export const jobCategoryFieldsSlice = createSlice({
	name: 'jobFields',
	initialState: initialState,
	reducers: {
		showLoading: (state) => {
			state.loading = true;
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(getAllJobCategoryFields.pending, (state) => {
				state.loading = true;
			})
			.addCase(getAllJobCategoryFields.fulfilled, (state, action) => {
				state.loading = false;
				state.jobFields = action?.payload?.result?.data || [];
			})
			.addCase(getAllJobCategoryFields.rejected, (state, action) => {
				state.message = action.payload;
				state.showMessage = true;
				state.loading = false;
				state.jobFields = [];
			})
			.addCase(getJobCategoryFieldsById.pending, (state) => {
				state.loading = true;
			})
			.addCase(getJobCategoryFieldsById.fulfilled, (state) => {
				state.loading = false;
			})
			.addCase(getJobCategoryFieldsById.rejected, (state, action) => {
				state.message = action.payload;
				state.showMessage = true;
				state.loading = false;
			})
			.addCase(deleteJobCategoryFields.pending, (state) => {
				state.loading = true;
			})
			.addCase(deleteJobCategoryFields.fulfilled, (state) => {
				state.loading = false;
			})
			.addCase(deleteJobCategoryFields.rejected, (state, action) => {
				state.message = action.payload;
				state.showMessage = true;
				state.loading = false;
			})
			.addCase(editJobCategoryFields.pending, (state) => {
				state.loading = true;
			})
			.addCase(editJobCategoryFields.fulfilled, (state) => {
				state.loading = false;
			})
			.addCase(editJobCategoryFields.rejected, (state, action) => {
				state.message = action.payload;
				state.showMessage = true;
				state.loading = false;
			})
			.addCase(addJobCategoryFields.pending, (state) => {
				state.loading = true;
			})
			.addCase(addJobCategoryFields.fulfilled, (state) => {
				state.loading = false;
			})
			.addCase(addJobCategoryFields.rejected, (state, action) => {
				state.message = action.payload;
				state.showMessage = true;
				state.loading = false;
			});
	},
});

export const { showLoading } = jobCategoryFieldsSlice.actions;

export default jobCategoryFieldsSlice.reducer;
